module.exports = __webpack_public_path__ + "img/avatar-empty.2e77a3e4.png";